import React from "react";


export function NameMA() {
    return(
        <div>
            <h4>Dipl.-Ing. Matthias Angerhausen</h4>
        </div>
    )
}

export function PositionMA() {
    return(
        <div>
            <h5 className="italic">Account Management & Vertrieb</h5>
        </div>
    )
}


export function DescriptionMA() {
    return (
        <div>
            <p>
                Matthias Angerhausen repräsentiert das immer offene Ohr für unsere Kunden.
                Er verantwortet den Vetrieb unserer Lösungen sowie die Kontakt- und Netzwerkpflege.
            </p>
        </div>
    );
}

export function BioMA() {
    return (
        <div>
            <p>
                Matthias Angerhausen ist ein erfahrener Maschinenbauingenieur mit umfassender Expertise in den
                Bereichen der Schweiß- und Fügetechnik. Ein besonderer Schwerpunkt seiner Arbeit liegt auf der
                Industrialisierung innovativer, teils neu entwickelter Fügetechnologien sowie der Optimierung
                bestehender Prozessabläufe. Dabei begleitet er den gesamten Entwicklungszyklus – von der ersten Idee
                bis zur erfolgreichen Serienumsetzung – und trägt maßgeblich zur Steigerung der technischen Effizienz bei.
                Darüber hinaus verfügt er über fundierte Erfahrung im technischen Vertrieb und in der strategischen
                Unternehmensentwicklung. Durch die enge Verzahnung von Technologieverständnis und Marktkenntnis gelingt
                es ihm, zukunftsfähige Lösungen sowohl technisch als auch wirtschaftlich erfolgreich zu gestalten.
            </p>
        </div>
    );
}

export function ExpertiseMA() {
    return (
        <div>
            <h3>Expertise</h3>
            <p>
                <ul>
                    <li>Systembetrachtung in der Schweiß- und Fügetechnik</li>
                    <li>Digitale Transformation von Prozessketten</li>
                    <li>Networking</li>
                </ul>
            </p>

        </div>
    );
}

